export const ADD_SUCCESS = 'Бонусная программа добавлена';
export const ADD_ERROR = 'Не удалось добавить бонусную программу';
